import React from 'react';

import GridContainer from 'components/Grid/GridContainer.js';
import GridItem from 'components/Grid/GridItem.js';
import Card from 'components/Card/Card.js';
import CardHeader from 'components/Card/CardHeader.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardBody from 'components/Card/CardBody.js';
import { Assignment } from '@material-ui/icons';
import { nDecimal } from 'hooks/Pipe';

export default function ReadSaleDate(props) {
  const { dataProduct } = props;

  return (
    <>
      <GridItem xs={12} sm={12} md={6}>
        <Card>
          <CardHeader icon>
            <CardIcon color="primary">
              <Assignment />
            </CardIcon>
            <h4 style={{ color: 'black' }}>Artículo venta</h4>
          </CardHeader>
          <CardBody>
            <GridContainer>
              <GridItem xs={12} md={3}>
                <h6>U.M venta</h6>
                <p>{dataProduct.SalUnitMsr || '-'}</p>
              </GridItem>
              <GridItem xs={12} md={3}>
                <h6>Unidades venta</h6>
                <p>{nDecimal(dataProduct.NumInSale) || '-'}</p>
              </GridItem>
              <GridItem xs={12} md={3}>
                <h6>Impuesto</h6>
                <p>{dataProduct.TaxCodeAR || '-'}</p>
              </GridItem>
              <GridItem xs={12} md={3}>
                <h6>U.M de empaque</h6>
                <p>{dataProduct.SalPackMsr || '-'}</p>
              </GridItem>
            </GridContainer>
          </CardBody>
        </Card>
      </GridItem>
      <GridItem xs={12} sm={12} md={6}>
        <Card>
          <CardHeader icon>
            <CardIcon color="primary">
              <Assignment />
            </CardIcon>
            <h4 style={{ color: 'black' }}>Medidas</h4>
          </CardHeader>
          <CardBody>
            <GridContainer>
              <GridItem xs={12} md={4}>
                <h6>Logintud</h6>
                <p>{nDecimal(dataProduct.SLength1)}</p>
              </GridItem>
              <GridItem xs={12} md={4}>
                <h6>Ancho</h6>
                <p>{nDecimal(dataProduct.SWidth1)}</p>
              </GridItem>
              <GridItem xs={12} md={4}>
                <h6>Altura</h6>
                <p>{nDecimal(dataProduct.SHeight1)}</p>
              </GridItem>
              <GridItem xs={12} md={4}>
                <h6>Unid. volumen</h6>
                <p>{dataProduct.SVolUnit_VolDisply || '-'}</p>
              </GridItem>
              <GridItem xs={12} md={4}>
                <h6>Volumen</h6>
                <p>{nDecimal(dataProduct.SVolume)}</p>
              </GridItem>
              <GridItem xs={12} md={4}>
                <h6>Peso</h6>
                <p>{nDecimal(dataProduct.SWeight1)}</p>
              </GridItem>
            </GridContainer>
          </CardBody>
        </Card>
      </GridItem>
    </>
  );
}
